import styled from 'styled-components';
export const LabelWrapper = styled.label `
  display: contents;
  cursor: pointer;
`;
export const CheckboxSlot = styled.div `
  position: relative;
  height: 20px;
  width: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
//# sourceMappingURL=BKJCheckboxListItem.styled.js.map